module.exports = __webpack_public_path__ + "static/media/blue-check.f27fea17.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blue-check.svg
// module id = 1262
// module chunks = 1